import React, { useState, useEffect, useRef } from "react";

/**
 * Beden serisi şeridi.
 *
 * Legacy davranış (default):
 *   indo        → amount dolu beden satırları
 *   highlight   → startIndex === indexxxx[index] (index bazlı)
 *   font        → helve-medium 8pt
 *
 * NEW ZARA modu (Page1'den props ile):
 *   indo           → newPriceLabel.article.sizeSerie ([{ name: '34' }, ...])
 *   highlightValue → currentSize.size ile DEĞER bazlı eşleşme (index değil)
 *   fontSize       → '6.276pt' (Helvetica Neue LT Std 65 Medium — helve-medium)
 * Diğer tüm ayarlar (kutu boyutları, gap, scale, renkler) değişmez.
 */
const RenderIndoItemsKıds = ({ indo, startIndex, indexxx, highlightValue, fontSize = '8pt' }) => {
  const [scale, setScale] = useState(1);
  const containerRef = useRef(null); // Kapsayıcı referansı
  const contentRef = useRef(null); // İçerik referansı
  const innerRef = useRef(null); // İçerik referansı

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current && contentRef.current) {
        const containerWidth = containerRef.current.offsetWidth; // Kapsayıcı genişliği
        const contentWidth = contentRef.current.scrollWidth; // İçerik genişliği
        // innerRef null olabilir (indo boş → hiç beden kutusu render edilmedi) — guard şart
        if (innerRef.current) {
          console.log("innerrefff", innerRef.current.scrollWidth);
        }
        if (containerWidth > 210) {
          const excessWidth = containerWidth - 210;
          const scaleFactor = (containerWidth - excessWidth) / containerWidth;
          setScale(scaleFactor);
        } else if (contentWidth > containerWidth) {
          setScale(containerWidth / contentWidth);
        } else {
          setScale(1); // Orijinal boyuta dön
        }
      }
    };

    const resizeObserver = new ResizeObserver(() => handleResize());
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    handleResize(); // İlk kontrol

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        ref={containerRef}
        style={{

          overflow: "hidden",
          maxWidth: "200px",
          display: "flex",

        }}
      >
        <div
          ref={contentRef}
          style={{
            height:"4mm",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            transform: `scaleX(${scale})`,
            transformOrigin: "left",
            transition: "transform 0.3s ease",
            margin: "0 auto",
            gap:"0.5mm"

          }}
        >
          {indo.map((item, index) => {
            // `indexxx` içindeki mevcut sırayı kontrol et
            // NEW ZARA: highlightValue verilmişse DEĞER bazlı eşleşme (currentSize.size)
            // Legacy: highlightValue yoksa index bazlı — indexxx gönderilmemiş olabilir (guard)
            const isHighlighted =
              highlightValue != null
                ? String(item?.name).trim() === String(highlightValue).trim()
                : Array.isArray(indexxx)
                  ? startIndex === indexxx[index]
                  : false;

            return (
              <div
                key={index}
                ref={innerRef}
                style={{
      height:"65%",
                 paddingLeft:"0.5mm",
                 paddingRight:"0.5mm",
               
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: isHighlighted ? "black" : "transparent",
                  color: isHighlighted ? "white" : "black",
                  textAlign: "center",
                }}
              >
                <p
                  className="helve-medium"
                  style={{ fontSize, margin: 0 , flexWrap: "nowrap",whiteSpace: "nowrap"}}
                >
                  {item?.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RenderIndoItemsKıds;
